import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";
import ListPermissaoVisualizacao from "./Permissoes/ListPermissaoVisualizacao";
import ListNotificacoes from "./Notificacao/ListNotificacoes";
import services from "../../services";
import "./styles.scss";
import NotificacaoForm from "./Notificacao/NotificacaoForm";
import PermissaoForm from "./Permissoes/PermissaoForm";
import Header from "../../components/Header";
import addMore from "../../assets/icons/addMore.png";

import {
  listarNotificacoes,
  listarTitulosNotificacoes,
} from "../../services/http/notificacoesService";
import { listarPermissoes } from "../../services/http/usuariosService";
import BannerForm from "./Banner/BannerForm";
import ListBanner from "./Banner/ListBanners";
import { getListagemBanner, getListagemBannerConfig } from "../../services/http/bannersServico";

const Configuracoes = ({}) => {
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [tipoFormulario, setTipoFormulario] = useState(null);
  const [notificacoes, setNotificacoes] = useState([]);
  const [banners, setBanners] = useState([]);
  const [idPermissaoEdicao, setIdPermissaoEdicao] = useState(null);
  const [notificacaoSelecionada, setNotificacaoSelecionada] = useState(false);
  const [idNotificacoesEdicao, setIdNotificacoesEdicao] = useState(null);

  const [idBannerEdicao, setIdBannerEdicao] = useState(null);
  const [bannerSelecionado, setBannerSelecionado] = useState(false);

  const [permissoes, setPermissoes] = useState([]);
  const [qtdNotificacoes, setQtdNotificacoes] = useState(0);
  const [listaNotificacoes, setlistaNotificacoes] = useState([]);
  const [novaEdit, setNovaEdit] = useState(false);
  const listarFavoritos = () => {
    listaDeFavoritos();
  };

  const listarPermissao = () => {
    trackPromise(
      listarPermissoes()
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const fnlistaNotificacoesSino = () => {
    trackPromise(
      listarTitulosNotificacoes(IdUser)
        .then((res) => {
          if (!res.fail && res.data) {
            setlistaNotificacoes(res.data);
            const naoVisualizadas = res.data.filter(
              (notificacao) => !notificacao.visualizado
            );
            setQtdNotificacoes(naoVisualizadas.length);
            services.storage.set("NOTIFICACAO", true);
            setNovaEdit(true);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const formulario = {
    notificacaoform: (
      <NotificacaoForm
        setNovaEdit={setNovaEdit}
        idNotificacoesEdicao={idNotificacoesEdicao}
        listarFavoritos={listarFavoritos}
        setTipoFormulario={setTipoFormulario}
        fnlistaNotificacoesSino={fnlistaNotificacoesSino}
      />
    ),
    permissaoform: (
      <PermissaoForm
        idPermissaoEdicao={idPermissaoEdicao}
        listarPermissao={listarPermissao}
      />
    ),
    bannerform: (
      <BannerForm
        setNovaEdit={setNovaEdit}
        idBannerEdicao={idBannerEdicao}
        listarFavoritos={listarFavoritos}
        setIdBannerEdicao={setIdBannerEdicao}
      />
    ),
  };

  const showForm = () => {
    return formulario[tipoFormulario];
  };

  const showPermissao = (value) => {
    setIdPermissaoEdicao(value);
    setNotificacaoSelecionada(false);
    setTipoFormulario("permissaoform");
  };

  const showNotificacaoEdit = (value) => {
    setIdNotificacoesEdicao(value);
    setNotificacaoSelecionada(true);
    setTipoFormulario("notificacaoform");
  };
  const showBanner = (value) => {
    setIdBannerEdicao(value);
    setBannerSelecionado(true);
    setTipoFormulario("bannerform");
  };

  useEffect(() => {
    listaDeFavoritos();
    listarPermissao();
    fnlistaNotificacoesSino();
    // listaBannersRecentes();
  }, []);

  const listaBanners = () => {
    trackPromise(
      getListagemBannerConfig()
        .then((res) => {
          if (!res.fail && res.data) {
            setBanners([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const listaDeFavoritos = () => {
    trackPromise(
      listarNotificacoes()
        .then((res) => {
          if (!res.fail && res.data) {
            setNotificacoes([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  useEffect(() => {
    listaBanners();
  }, []);
  return (
    <>
      <Header
        style={{ marginBottom: "2rem" }}
        mostrarPesquisar={false}
        novaEdit={novaEdit}
        setNovaEdit={setNovaEdit}
        notificacaoVisualizada={notificacoes}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <ListPermissaoVisualizacao
              showPermissao={showPermissao}
              permissoes={permissoes}
              notificacaoSelecionada={notificacaoSelecionada}
            />
            <ListNotificacoes
              notificacoes={notificacoes}
              showNotificacao={showNotificacaoEdit}
            />
            <ListBanner banners={banners} showBanner={showBanner} />
          </div>
          {tipoFormulario == null && (
            <div className="col-md-9">
              <div
                className="row"
                style={{ borderBottom: "1px solid #898989" }}
              >
                <div
                  style={{ padding: "0px" }}
                  className="col-md-7 col-sm-7 col-xl-7 mb-3"
                >
                  <span className="titulo-perm">
                    Permissões de visualização
                  </span>
                </div>

                <div className="">
                  <span
                    onClick={() => setTipoFormulario("permissaoform")}
                    className="mr-3 pointer"
                  >
                    <img src={addMore}></img> Adicionar permissão
                  </span>
                  <span
                    onClick={() => {
                      setTipoFormulario("notificacaoform");
                      setIdNotificacoesEdicao(null);
                    }}
                    className="mr-3 pointer"
                  >
                    <img src={addMore}></img> Nova notificação
                  </span>
                  <span
                    onClick={() => {
                      setTipoFormulario("bannerform");
                      setIdBannerEdicao(null);
                    }}
                    className=" mr- pointer3"
                  >
                    <img src={addMore}></img> Novo Banner
                  </span>
                </div>
              </div>
            </div>
          )}
          {showForm()}
        </div>
      </div>
    </>
  );
};

export default Configuracoes;
